"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettlementFeeSnapshotV1Schema = exports.SerializedFeePlanSchema = void 0;
exports.parseSettlementFeeSnapshot = parseSettlementFeeSnapshot;
const zod_1 = require("zod");
const event_1 = require("./event");
const service_fee_terms_1 = require("./service-fee-terms");
const Percentage = zod_1.z.string().regex(/^\d+(\.\d+)?$/).refine((value) => Number(value) <= 100);
const FixedFee = zod_1.z.string().regex(/^\d+(\.\d+)?$/);
const Days = zod_1.z.number().int().nonnegative();
const Timestamp = zod_1.z.string().datetime({ offset: true });
// Data only: the resolved plan includes inherited defaults at contract checkout.
exports.SerializedFeePlanSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    userId: zod_1.z.string().min(1).optional(),
    receivingPeriod: zod_1.z.enum(['D2', 'D5', 'D14', 'D30']),
    receivingDays: Days.optional(),
    receivingPlanVersionId: zod_1.z.string().min(1).optional(),
    currency: zod_1.z.union([event_1.CurrencySchema, zod_1.z.literal('*')]),
    nationalFeePercentage: Percentage,
    internationalFeePercentage: Percentage,
    pixFeePercentage: Percentage,
    nationalReservePercentage: Percentage,
    globalReservePercentage: Percentage,
    nationalReserveDays: Days,
    globalReserveDays: Days,
    nationalFixedFee: FixedFee,
    internationalFixedFee: FixedFee,
    microFeePercentage: Percentage.optional(),
    effectiveFrom: Timestamp,
    effectiveTo: Timestamp.optional(),
    settlementTiming: zod_1.z.literal('CONNECT_BR_CARD').optional(),
    overriddenFields: zod_1.z.array(zod_1.z.enum([
        'nationalFeePercentage', 'internationalFeePercentage', 'pixFeePercentage',
        'nationalReservePercentage', 'globalReservePercentage', 'nationalReserveDays',
        'globalReserveDays', 'nationalFixedFee', 'internationalFixedFee',
    ])).optional(),
}).strict();
exports.SettlementFeeSnapshotV1Schema = zod_1.z.object({
    version: zod_1.z.literal(1),
    producerId: zod_1.z.string().min(1),
    currency: zod_1.z.literal('BRL'),
    paymentMethod: zod_1.z.enum(['CREDIT_CARD', 'APPLE_PAY', 'GOOGLE_PAY']),
    capturedAt: Timestamp,
    serviceFee: service_fee_terms_1.ServiceFeeTermsSchema.optional(),
    plan: exports.SerializedFeePlanSchema,
}).strict().superRefine((snapshot, ctx) => {
    if (snapshot.plan.currency !== '*' && snapshot.plan.currency !== snapshot.currency) {
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, path: ['plan', 'currency'], message: 'fee snapshot plan currency mismatch' });
    }
    if (snapshot.plan.userId !== undefined && snapshot.plan.userId !== snapshot.producerId) {
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, path: ['plan', 'userId'], message: 'fee snapshot plan producer mismatch' });
    }
    if (snapshot.plan.effectiveTo !== undefined && Date.parse(snapshot.plan.effectiveTo) <= Date.parse(snapshot.plan.effectiveFrom)) {
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, path: ['plan', 'effectiveTo'], message: 'fee snapshot plan validity is invalid' });
    }
});
function parseSettlementFeeSnapshot(input) {
    return exports.SettlementFeeSnapshotV1Schema.parse(input);
}
//# sourceMappingURL=fee-snapshot.js.map